import { Component, OnDestroy, OnInit } from '@angular/core';

import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';

@Component({
	selector: 'app-lift-stats-v2',
	styleUrls: ['./lift-stats-v2.component.css'],
	templateUrl: './lift-stats-v2.component.html'
})
export class LiftStatsV2Component extends LiftStatsComponent implements OnInit, OnDestroy {
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		if (this.sectionclass.toLowerCase().includes('r6') || this.sectionclass.toLowerCase().includes('v6')) {
			this.isR6Enabled = true;
		}
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
